import { HttpClient } from '@/shared/lib/http-client';

export const fetchNotifications = async ({ page = 1, onlyUnreadMessages = false }) => {
  const response = await HttpClient.get('/notifications', {
    page: page,
    read: !onlyUnreadMessages,
  });

  return response.data;
};
